
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { RankDisplay } from "./RankDisplay";
import { useTranslation } from "@/hooks/useTranslation";
import { StarRating } from "@/components/review/StarRating";

interface Airport {
  id: number;
  name: string;
  location: string;
  iata_code: string;
  currentRank?: number;
  reviews: {
    average_score: number;
    total_reviews: number;
    hand_check_success_rate: number;
  };
}

interface TopAirportsCardProps {
  title: string;
  airports: Airport[];
  startRank: number;
  isWorst?: boolean;
}

export const TopAirportsCard = ({ title, airports, startRank, isWorst = false }: TopAirportsCardProps) => {
  const { t } = useTranslation();
  
  if (airports.length === 0) {
    return null;
  }

  return (
    <Card className="p-6">
      <h2 className="text-xl font-semibold mb-4">{title}</h2>
      <div className="space-y-4">
        {airports.map((airport, index) => (
          <div key={airport.id} className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <RankDisplay rank={isWorst ? airport.currentRank || startRank + index : startRank + index} />
              <div>
                <Link 
                  to={`/airport/${airport.iata_code}`}
                  className="font-medium hover:underline"
                >
                  {airport.name}
                </Link>
                <div className="text-sm text-muted-foreground">
                  {airport.location}
                </div>
              </div>
            </div>
            <div className="text-right">
              <div className="flex items-center gap-2">
                <StarRating score={airport.reviews.average_score} />
              </div>
              <div className="text-sm text-muted-foreground">
                {airport.reviews.hand_check_success_rate.toFixed(0)}% success
              </div>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
